module.exports = __webpack_public_path__ + "static/media/login-girl.8c0869a6.png";